import Vue from 'vue'
import axios from "axios"

Vue.mixin({
    data() {
        return {
            primaryButtonColor: "#424EC4",
            primaryYellowColor: "#FFCD00",
            primaryWhiteColor: "#FFFFFF",
            invalidFormLabelColor: "#FF0021",
            containerHeight: null,
        }
    },
    methods: {
        getFormattedDate(dateString) {
            const options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
            return new Date(dateString).toLocaleDateString(undefined, options)
        },
        isRecentDate(date) {
            console.log('date', date);

            const now = new Date();
            const targetDate = new Date(date);
            const sixMonthsAgo = new Date();
            sixMonthsAgo.setMonth(now.getMonth() - 6);

            // Return true if the date is within the last six months
            return targetDate >= sixMonthsAgo;
        },
        checkNextEvent() {
            const now = Date.now();
            const twoWeeksFromNow = now + 14 * 24 * 60 * 60 * 1000; // 2 weeks in milliseconds

            this.events.upcoming.items.forEach((element) => {
                element.sortBy = new Date(element.startAt)
                return element;
            });

            // Sort strating from nearest next event, and find the next event within the next 2 weeks
            this.nextEvent = this.events.upcoming.items.sort((a, b) => a.sortBy > b.sortBy ? 1 : -1).find(event => {
                const eventTime = new Date(event.startAt).getTime();
                return eventTime > now && eventTime <= twoWeeksFromNow;
            });

            if (this.nextEvent) {
                this.showBanner = true;
                this.showSecondaryBanner = false;
                this.updateTimer(); // Start the countdown
                // this.eventsPageTitle = 'Project Spectrum Events';
            } else {
                console.log("No upcoming events within 2 weeks");

                this.showBanner = false;
                this.showSecondaryBanner = true; // Show the default banner if no events within 2 weeks
            }
            this.$emit("apply-event-banner", this.showBanner);
        },
        updateTimer() {
            if (this.nextEvent) {
                const now = Date.now();
                const eventTime = new Date(this.nextEvent.startAt).getTime();
                this.timeRemaining = Math.max(0, eventTime - now);

                if (this.timeRemaining > 0) {
                    setTimeout(this.updateTimer, 1000);
                } else {
                    this.checkNextEvent(); // Event has passed, check for next one
                }
            }
        },
        async getEvents() {
            // Static data for testing
            // const eventsData = [
            //   {
            //     description: "<p>100+ businesses are cyber-secure with Project Spectrum. Learn how to save your business from non-ethical hackers.</p>",
            //     endAt: "Monday, July 30, 2024 11:00 PM",
            //     eventTitle: "Join our FREE event to protect your business from cyber-attacks",
            //     startAt: "Monday, July 30, 2024 7:00 PM"
            //   },
            //   {
            //     description: "<p>100+ businesses are cyber-secure with Project Spectrum. Learn how to save your business from non-ethical hackers.</p>",
            //     endAt:"Friday, November 14th, 2024 7:00 PM",
            //     eventTitle: "Join our FREE event to protect your business from cyber-attacks",
            //     startAt: "Thursday November 12, 2024 2:50 PM"
            //   }
            // ];
            // console.log("Events",Date(eventsData[1].startAt) > Date.now());
            // console.log("Events",Date(eventsData[1].startAt));

            // const now = Date.now();
            // this.events.upcoming.items = eventsData.filter(
            //   (item) => new Date(item.startAt) > now
            // );
            // console.log("Upcoming Events",this.events.upcoming.items);
            // this.events.upcoming.itemCount = this.events.upcoming.items.length;

            await axios
                .get("/api/resources/events")
                .then(response => {
                    console.log("Events", response.data.Items)

                    // Only storing upcoming events
                    this.events.upcoming.items = response.data.Items.filter(
                        (item) => new Date(item.startAt) > Date.now()
                    )
                    this.events.upcoming.itemCount = this.events.upcoming.items.length;

                    // Storing past event
                    this.events.past.items = response.data.Items.filter(
                        (item) => new Date(item.startAt) <= Date.now()
                    )
                    this.events.past.itemCount = this.events.past.items.length;
                })
                .catch(async (error) => {
                    console.error(error)
                });

            this.checkNextEvent();
        },
        async getCyberCircuits() {
            await axios
                .get("/api/resources/cybercircuits")
                .then(async (response) => {
                    console.log("Cyber Circuits", response.data.Items)
                    this.cyberCircuits.upcoming.items = response.data.Items.filter(
                        (item) => new Date(item.date) > Date.now()
                    );
                    this.cyberCircuits.upcoming.itemCount = this.cyberCircuits.upcoming.items.length;

                    this.cyberCircuits.past.items = response.data.Items.filter(
                        (item) => new Date(item.date) <= Date.now()
                    );
                    this.cyberCircuits.past.itemCount = this.cyberCircuits.past.items.length;
                })
                .catch(async (error) => {
                    console.error(error)
                });
        },
        updateUrlQueryParam(splitValue, queryParamArray) {
            let currentLocationUrl = window.location.href;

            let [mainUrl, queryParamsUrl] = currentLocationUrl.split(splitValue);
            currentLocationUrl = `${mainUrl}${queryParamsUrl}`;
            const urlObj = new URL(currentLocationUrl);

            for (let i = 0; i < queryParamArray.length; i++) {
                const { param, value } = queryParamArray[i];
                urlObj.searchParams.set(param, value);
            }

            currentLocationUrl = urlObj.toString();
            [mainUrl, queryParamsUrl] = currentLocationUrl.split('?');

            currentLocationUrl = queryParamsUrl ? `${mainUrl}${splitValue}?${queryParamsUrl}` : `${mainUrl}${splitValue}`;
            document.location.href = currentLocationUrl;
        },
        goToPreviousOrNextBlogItem(id, urlPath) {
            let currentLocationUrl = window.location.href;
            let [mainUrl, queryParams] = currentLocationUrl.split(urlPath);
            currentLocationUrl = `${mainUrl}${queryParams}`;

            const urlObj = new URL(currentLocationUrl);
            urlObj.searchParams.set("id", id);

            [mainUrl, queryParams] = urlObj.toString().split("?");
            window.location.href = `${mainUrl}${urlPath}?${queryParams}`;
            window.location.reload();
        },
        async downloadUrl(url, filename) {
            const response = await fetch(url);

            if (response.status !== 200 && !response.ok) {
                throw new Error(`Unable to download ${filename}`);
            }

            const blob = await response.blob();
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);

            return filename;
        },
        defaultProjectSpectrumFeatureTemplate(subject) {
            return `
				<p style='text-align: left; font-size: 16px; padding-left:5px;'>We are updating our courses to reflect the latest version of ${subject} and other recent changes.</p>
				<p style='text-align: left; font-size: 16px; padding-left:5px;'>Thank you for your patience, the courses will be back soon.</p>

				<p style='text-align: left; margin-bottom: 0; font-size: 16px; padding-left:5px;'>Best regards,</p>
				<p style='text-align: left; font-size: 16px; padding-left:5px;'>The Project Spectrum Team</p>
            `;
        },
        computePageContainerHeight() {
            const navHeight = document.querySelector('nav').clientHeight;
            const footerHeight = document.querySelector('.v-footer').clientHeight;
            const windowHeight = window.innerHeight + 3;

            this.containerHeight = windowHeight - footerHeight - navHeight;
        },
    }
})